import { render, staticRenderFns } from "./LogsHistoryModal.vue?vue&type=template&id=ac278960&"
import script from "./LogsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./LogsHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports